module.exports = __webpack_public_path__ + "media/jojossmovie1_supershrink.ad9c7f87.mp4";